import { render, staticRenderFns } from "./Wp_order_count_self_detail_model.vue?vue&type=template&id=0477c1b2&scoped=true&"
import script from "./Wp_order_count_self_detail_model.vue?vue&type=script&lang=js&"
export * from "./Wp_order_count_self_detail_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0477c1b2",
  null
  
)

export default component.exports